
import { useNavigate } from "react-router-dom"

const Missing = () => {
    let navigate = useNavigate()
    return (
        <div class="message-box">
            <h1>404</h1>
            <p>Page not found</p>
            <div class="buttons-con">
                <div class="action-link-wrap">
                    <button onclick={() => { navigate(-1) }} class="link-button link-back-button">Go Back</button>
                    <button class="link-button">Go to Home Page</button>
                </div>
            </div>
        </div>
    )
}

export default Missing
